import { render, staticRenderFns } from "./import-fixed-allowance.vue?vue&type=template&id=f6845272"
import script from "./import-fixed-allowance.vue?vue&type=script&lang=js"
export * from "./import-fixed-allowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports